module.exports = __webpack_public_path__ + "img/bg-top-section.548a520a.webp";